<li class="nav-item text-left">
    <a href="/alertas">
        <i class="bi bi-bell"></i>
        <span class="links_name">Alertas</span>
    </a>
</li>
<li class="nav-item text-left">
    <a href="/proveedores">
        <i class="bi bi-shop-window"></i>
        <span class="links_name">Provedores</span>
    </a>
    <span class="tooltip"></span>
</li>